import { render, staticRenderFns } from "./layout-title.vue?vue&type=template&id=cdd68fd2&scoped=true"
import script from "./layout-title.vue?vue&type=script&lang=js"
export * from "./layout-title.vue?vue&type=script&lang=js"
import style0 from "./layout-title.vue?vue&type=style&index=0&id=cdd68fd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd68fd2",
  null
  
)

export default component.exports